module.exports = ".btn-audio-move {\r\n    background-color: transparent;\r\n    color: #444444;\r\n    -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n}\r\n.btn-audio-move:hover:enabled {\r\n    color: green;\r\n}\r\n.btn-audio-main {\r\n    background-color: #444444;\r\n    color: white;\r\n    -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n}\r\n.btn-audio-main:hover:enabled {\r\n    background-color: green;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/audio-player/audio-player.component.css
// module id = ./src/app/components/audio-player/audio-player.component.css
// module chunks = main